import * as effects from 'redux-saga/effects';

import { Backend } from '../../Backend/Backend';
import { ISearchActionTypes } from './Types';
import {
  launchSearch,
  launchSearchError,
  launchSearchSuccess,
  paginateSearchSuccess,
} from './Actions';

function* handleLaunchSearch(action: ReturnType<typeof launchSearch>) {
  const backend = Backend.getInstance();
  try {
    const results = yield effects.apply(backend, backend.launchSearch, [
      action.payload,
    ]);
    if (results) {
      yield effects.put(launchSearchSuccess(results));
    } else {
      throw new Error('response is not a search response type');
    }
  } catch (err) {
    if (err instanceof Error) {
      yield effects.put(launchSearchError(err.message));
    } else if (typeof err === 'string') {
      yield effects.put(launchSearchError(err));
    } else {
      yield effects.put(launchSearchError('Unknown error occurred'));
      console.log(err);
    }
  }
}

function* handlePaginateSearch() {
  try {
    const backend = Backend.getInstance();
    let params = yield effects.select((state) => state.search.params);

    const results = yield effects.apply(backend, backend.launchSearch, [
      params,
    ]);
    yield effects.put(paginateSearchSuccess(results));
  } catch (err) {}
}

function* watchSearch() {
  yield effects.takeEvery(ISearchActionTypes.LAUNCH_SEARCH, handleLaunchSearch);
  yield effects.takeEvery(
    ISearchActionTypes.PAGINATE_SEARCH,
    handlePaginateSearch
  );
}

export function* SearchSaga() {
  yield effects.all([effects.fork(watchSearch)]);
}
